import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {ActivatedRoute} from '@angular/router';
import {HostingService} from "../hosting.service";
import {Subscription} from 'rxjs';
import {AddCustomDomainDialogComponent} from "../domains/add-domain-dialog/add-custom-domain-dialog.component";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {HostingDomainsZoneDataMapper} from "../domains/hosting-domains-zone-mapper";
import {User} from "../../../../user/user";
import {filter, first, switchMap} from 'rxjs/operators';
import {DbModalService} from "../../../../modules/modal/modal";

@Component({
    templateUrl: './hosting-domains-manage-all.component.html',
    styleUrls: ['./hosting-domains-manage-all.component.scss'],
    standalone: false
})
export class HostingDomainsManageAllComponent implements OnInit, OnDestroy {

  public zones: any;
  public hostingZonesData: any;
  public zoneLimit: number;
  public user: User;
  public subscriptions: Subscription[];

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService,
    private _route: ActivatedRoute,
    private _modalService: DbModalService
  ) {}

  ngOnInit(): void {
    this.hostingZonesData = this._route.snapshot.data['hostingZonesData'];
    this.addEventHandlers();
    this.getZones();
  }

  private addEventHandlers(): void {
    this.subscriptions = [];
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser)),
        first()
      )
      .subscribe((userSubscription: User) => {
        this.user = userSubscription;
        this.zoneLimit = this.user.additionalWebsiteCount ? parseInt(this.user.hosting_services.zone_limit.parameter_value, 10) + (parseInt(this.user.additionalWebsiteCount, 10) * parseInt(this.user.hosting_services.additional_zone_limit.parameter_value, 10)) : parseInt(this.user.hosting_services.zone_limit.parameter_value, 10);
      });

  }

  private getZones() {
    this._hostingService.getZones()
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        if (response.success) {
          this.hostingZonesData = response.data.map( (zone) => HostingDomainsZoneDataMapper.map(zone));
        }
      });
  }


  ngOnDestroy(): void {
  this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
  if (this.subscriptions) {
   this.subscriptions.forEach((subscription: Subscription): void => {
     subscription.unsubscribe();
   });
  }
  this.subscriptions = null;
  }

  public addZone() {
    const modal = this._modalService.open(AddCustomDomainDialogComponent, {width: 700});
    modal.componentInstance.fromHostingManageAll = true;
    modal.closed.subscribe((value) => {
      if (value && value.success) {
        this.getZones();
      }
    });
  }

}
